var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounEventCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4694 7.76557H21.7301V6.61362H19.682V7.76557H12.834V6.61362H10.7859V7.76557H9.04665C7.84592 7.76557 6.86877 8.74253 6.86877 9.94345V24.0198C6.86877 25.2205 7.84574 26.1977 9.04665 26.1977H23.4691C24.6698 26.1977 25.647 25.2207 25.647 24.0198L25.6471 9.94345C25.6471 8.74253 24.67 7.76557 23.4693 7.76557H23.4694ZM14.769 23.9818L10.6652 19.8777L12.1136 18.4298L14.8024 21.1188L20.4197 15.7592L21.8337 17.2412L14.769 23.9818ZM23.5992 12.5647H8.9171V9.94377C8.9171 9.87234 8.97549 9.81395 9.04692 9.81395H10.7862V11.1579H12.8343V9.81395H19.6823V11.1579H21.7303V9.81395H23.4696C23.541 9.81395 23.5994 9.87234 23.5994 9.94377L23.5992 12.5647Z",
    fill: "#FF3C31"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.99603,
    y: 13.5312,
    width: 14.875,
    height: 11,
    fill: "#FF3C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6335 16.4981L13.9001 15.2315L20.2335 21.565L18.967 22.8315L12.6335 16.4981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6335 21.5644L18.967 15.231L20.2335 16.4975L13.9001 22.8309L12.6335 21.5644Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounEventCancel);
export default __webpack_public_path__ + "static/media/noun-event-cancel.ababb75c3f088b594fe15b59aa1b2ba0.svg";
export { ForwardRef as ReactComponent };